import React from 'react';
import Card from '../../ui/Card';
import DescriptionPanel from '../../ui/DescriptionPanel';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
import ChannelWiseROIChart from './ChannelWiseROIChart';
import SpendVsRevenueChart from './SpendVsRevenueChart';
import EfficiencyRankingChart from './EfficiencyRankingChart';
import ROIByRegionChannelTable from './ROIByRegionChannelTable';
const ChannelROIAnalysisDashboard: React.FC = () => {
  const kpis = [{
    title: 'Avg ROI %',
    value: '267%',
    change: '+18%',
    isPositive: true,
    subtitle: 'Across all channels'
  }, {
    title: 'Best Performing Channel',
    value: 'Digital',
    change: '342% ROI',
    isPositive: true,
    subtitle: 'Highest return'
  }, {
    title: 'Worst Performing Channel',
    value: 'Outdoor',
    change: '128% ROI',
    isPositive: false,
    subtitle: 'Needs optimization'
  }];
  return <div data-id="element-6871">
      <DescriptionPanel title="Channel ROI Analysis" description="Strategic evaluation of marketing channel effectiveness and return on investment. Compare channel performance, analyze spend efficiency, and identify optimization opportunities to maximize marketing budget allocation and drive higher returns." insights={['Digital channels leading with 342% ROI - 3.4x return on investment', 'Average ROI across all channels at 267% with 18% improvement', 'BTL activities showing strong efficiency at ₹1,850 cost per conversion', 'Outdoor advertising underperforming at 128% ROI - requires strategy review']} data-id="element-6872" />
      {/* KPI Tiles */}
      <div className="mb-8" data-id="element-6873">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-6874">
          Channel ROI Metrics
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-6875">
          {kpis.map((kpi, index) => <Card key={index} className="p-6 bg-gradient-to-br from-white to-gray-50" data-id="element-6876">
              <div className="flex flex-col h-full" data-id="element-6877">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1" data-id="element-6878">
                  {kpi.title}
                </div>
                <div className="text-xs text-gray-400 mb-3" data-id="element-6879">{kpi.subtitle}</div>
                <div className="text-4xl font-bold text-gray-900 mb-3" data-id="element-6880">
                  {kpi.value}
                </div>
                <div className={`text-sm flex items-center font-semibold ${kpi.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-6881">
                  {kpi.isPositive ? <TrendingUpIcon size={16} className="mr-1" data-id="element-6882" /> : <TrendingDownIcon size={16} className="mr-1" data-id="element-6883" />}
                  {kpi.change}
                </div>
              </div>
            </Card>)}
        </div>
      </div>
      {/* Channel-wise ROI Chart - Full Width */}
      <ChannelWiseROIChart data-id="element-6884" />
      {/* Main Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-6885">
        <SpendVsRevenueChart data-id="element-6886" />
        <EfficiencyRankingChart data-id="element-6887" />
      </div>
      {/* ROI by Region & Channel Table */}
      <ROIByRegionChannelTable data-id="element-6888" />
    </div>;
};
export default ChannelROIAnalysisDashboard;